export default __webpack_public_path__ + "static/media/IMG_0242.30e48780.jpeg";